import { render, staticRenderFns } from "./queue-statistic.vue?vue&type=template&id=621063bd&scoped=true&"
import script from "./queue-statistic.vue?vue&type=script&lang=ts&"
export * from "./queue-statistic.vue?vue&type=script&lang=ts&"
import style0 from "./queue-statistic.vue?vue&type=style&index=0&id=621063bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621063bd",
  null
  
)

export default component.exports